import Utils from '@/core/utils/Utils';

/**
 * Представляет часть файла при загрузке по частям (chunked upload)
 * Используется для разбиения больших файлов на управляемые части
 */
class FileChunk {

  blob: Blob;
  start: number;
  end: number;
  chunkNumber: number;
  size: number;

  constructor(blob: Blob, start: number, end: number, chunkNumber: number) {
    this.blob = blob;
    this.start = start;
    this.end = end;
    this.chunkNumber = chunkNumber;
    this.size = blob.size;
  }

  get formattedSize(): string {
    return Utils.file.formatSize(this.size);
  }
}

export default FileChunk;
